import React from 'react';
import classNames from 'classnames';
import FeedLayoutBox from '@app/external/feed-page/components/feed-layout-box/feed-layout-box';
import { getIsCreatedWithResponsiveEditor } from '../../selectors/app-settings-selectors';
import { useSelector } from '../runtime-context';
import styles from './header-desktop.scss';

type Props = {
  left: React.ReactNode;
  right: React.ReactNode;
  className?: string;
};

const HeaderDesktop: React.FC<Props> = ({ left, right, className }) => {
  const createdWithResponsiveEditor = useSelector(getIsCreatedWithResponsiveEditor);
  const spacer = <div style={{ flexGrow: 1 }}></div>;

  return (
    <FeedLayoutBox
      className={classNames(styles.root, className, 'blog-header-background-color')}
      contentClassName={styles.content}
      data-hook="blog-desktop-header-container"
    >
      {left}
      {spacer}
      {!createdWithResponsiveEditor && right}
    </FeedLayoutBox>
  );
};

export default HeaderDesktop;
